// React
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
// Material
import {withStyles} from '@material-ui/core/styles';
import {Tooltip, Button} from '@material-ui/core';
// Styles
import './styles.scss';

const PrimaryTooltip = withStyles(() => ({
    tooltip: {
        backgroundColor: '#565671',
        color: '#FFF',
        maxWidth: 300,
        padding: 10,
        borderRadius: 10,
        fontWeight: 300,
        fontSize: 12
    },
}))(Tooltip);

const SecondaryTooltip = withStyles(() => ({
    tooltip: {
        backgroundColor: '#FFF',
        color: '#565671',
        maxWidth: 300,
        padding: 10,
        borderRadius: 10,
        fontWeight: 300,
        fontSize: 12
    },
}))(Tooltip);

class CommonTooltip extends Component {
    render() {
        const {text, type} = this.props;
        return (
            type === "secondary" ?
                <SecondaryTooltip
                    title={text}
                    placement={'right'}
                    interactive
                >
                    <Button className={"btn_tooltip btn_tooltip_secondary"}>?</Button>
                </SecondaryTooltip> :
                <PrimaryTooltip
                    title={text}
                    placement={'right'}
                    interactive
                >
                    <Button className={"btn_tooltip btn_tooltip_primary"}>?</Button>
                </PrimaryTooltip>

        );
    }
}

export default withTranslation('common')(CommonTooltip);